import React from "react";
import PropTypes from 'prop-types';

import { TextField } from "@mui/material";

export default class Input extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        custom: PropTypes.object,
    };

    static defaultProps = {
        data: {},
        custom: {},
    };

    onKeyUp(onEnter, onKeyUp, e) {
        const { value } = e.target;

        if (onKeyUp?.apply)
            onKeyUp(value, e);

        if (e.code === "Enter")
            onEnter(value, e);
    }

    render() {
        const { data, custom } = this.props;
        const { onEnter } = custom;
        const { onKeyUp } = data;

        if (onEnter?.apply)
            data.onKeyUp = this.onKeyUp.bind(this, onEnter, onKeyUp);

        return (
            <TextField
                variant="outlined"
                spellCheck="false"
                autoComplete="off"
                {...data}
            />
        );
    }
}